import { transform } from '@utils/intl_lang'
/** 直播状态 */
enum liveStatusEnum {
  NOT_START = '0',
  PLAYING = '1',
  COMPLETE = '2',
  PLAYING_BACK = '3',
  INVALID = '4',
}
/** 流状态 */
enum streamStatus {
  /** 开始推流 */
  START = 1,
  /** 停止推流 */
  SHUT = 2,
  /** 流异常中断 */
  INTERRUPT = 102,
  /** 流（异常中断状态下）恢复正常 */
  CONTINUE = 103,
  /* 混流停止 */
  MIX_STOP = 115
}
const liveStatusName = {
  // '未开始'
  '0': transform('not_started'),
  // '进行中'
  '1': transform('ongoing'),
  // '已结束'
  '2': transform('is_over'),
  // '回放中'
  '3': transform('playing_back'),
  // '无效直播'
  '4': transform('invalid_live'),
}
enum statCodeEnum {
  ALREADY_COMPLETE = '3',
  ALREADY_DELETE = '4',
}
enum userAction {
  /** 用户加入直播, Group消息 */
  ENTER_LIVE = 1,
  /** 用户退出直播, Group消息 */
  EXIT_LIVE = 2,
  /** 直播结束 */
  THE_END = 8,
  /** 下麦通知 */
  STOP_PLAY_NOTIFY = 4103,
  /** 上麦通知 */
  START_PLAY_NOTIFY = 4102,
  /** 跟新麦序 */
  UPDATE_PLAY_NOTIFY = 4104,
  /** 成员进出通知 */
  MEMBER_IN_OUT_NOTIFY = 4112,
  /** 聊天消息, 包括管理员消息、主播消息、观众聊天消息、观众提问消息 */
  UPDATE_MESSAGE = 7,
  /** 更新直播间相关信息 点赞，礼物，观众人数等 */
  UPDATE_LIVEROOM_INFO = 11,
  /** 多人观看签到签出信息 */
  MANY_WATCH_SIGN = 6760,
  /** 直播间敏感词 */
  ROOM_SENS_WORD = 6780,
  /** 七牛普通流更新 */
  QINIU_DEFAULT_STREAM = 6792,
}
enum streamTypeEnum {
  /** 手机连麦 */
  PHONE = 1001,
  /** pc端主视频 */
  PC_CAERMA = 2001,
  /** pc端分享桌面(只有pc能分享桌面) */
  PC_SHARE_DES = 3001,
  /** pc端分享桌面(只有pc能分享窗口) */
  PC_SHARE_WINDOW = 4001,
  /** 摄像机推流 */
  OUT_CAERMA_WINDOW = 5001,
  /** pc端分享桌面(只有pc能分享视频) */
  PC_MEDIA = 6001,
}
enum userActionMsgParam {
  /** 主播群发消息 */
  ANCHOR_MESSAGE = 6,
  // 普通聊天消息
  TALK_MESSAGE = 7,
  /** 单个禁言 */
  SINGLE_FORBIDDEN = 9,
  /** 系统消息 */
  SYSTEM_MESSAGE = 12,
  // 禁言开关
  SHUT_UP_TOGGLE = 13,
  /** 签到 */
  SIGN_IN = 18,
  // 主播公告
  ACHOR_NOTICE = 20,
  // 助教
  HELP_ACHOR_NOTICE = 21,
  // 金管家来人提示消息
  HELP_JGJ_PERSON_MES = 22,
  /** 取消禁言 */
  CANCEL_FORBIDDEN_MESSAGE = 6720,
}
// enum userActionParam {
//   /** 聊天消息, 包括管理员消息、主播消息、观众聊天消息、观众提问消息 */
//   TALK_MESSAGE = 7,
//   actionParam = 13
//   /** 更新直播间相关信息 点赞，礼物，观众人数等 */
//   UPDATE_LIVEROOM_INFO = 13,
// }

enum verificationTypeEnum {
  FACE_AND_CLOCKIN = 0,
  CLOCK_IN = 1,
  FACE = 2,
}

// 人社资源标识（0：非培训资源 1：培训资源 2：培训资源对接监管平台
enum resourceFlagEnum {
  NOT_TRAIN = '0',
  TRAIN = '1',
  TRAIN_JION = '2',
}

// 是否有学习权限（0：没有学习权限 1：普通课程/直播学习权限 2：监管平台学习权限 ）
enum learnAbleEnum {
  NO_AUTH = '0',
  NORMAL = '1',
  PLATFORM = '2',
}

enum resourceTypeEnum {
  LIVE = 31,
  REPLAY = 33,
}

export {
  liveStatusEnum,
  liveStatusName,
  userAction,
  userActionMsgParam,
  streamTypeEnum,
  statCodeEnum,
  streamStatus,
  verificationTypeEnum,
  resourceFlagEnum,
  learnAbleEnum,
  resourceTypeEnum,
}
